import { OneDeleteGroupDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import { OneCreateAction, OneCreationActionResolver } from 'modules/core/lib/oneCreateActions/types'
import { POSTS_POLICIES } from 'modules/posts/lib/postsPolicies'

const useDeleteGroupActionResolver: OneCreationActionResolver = () => {
  const [deleteGroup, { loading }] = useMutation(OneDeleteGroupDocument, {
    extractorFn: (data) => data.postsMutations.deletePostsGroup,
    errorPolicy: 'all',
  })

  const deleteGroupHandler = async (args: { groupId: string }) => {
    const result = await deleteGroup({
      variables: {
        id: args.groupId,
      },
    })

    const handled = handleResult(result, (_errors) => {})

    if (handled.success) {
      return { success: true as const, data: args }
    }

    return handled
  }

  return {
    resolver: deleteGroupHandler,
    loading,
  }
}

export const DeleteGroupAction: OneCreateAction = {
  actionResolver: useDeleteGroupActionResolver,
  policies: [POSTS_POLICIES.postsManage],
}
